import { For, Show } from "solid-js";
import { useDenominationsGridV2Context } from "../context/denominations_grid_v2_context";

function CheckIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3L4.5 8.5L2 6"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function AmountSelectorLonger() {
  const gridState = useDenominationsGridV2Context();
  const { externalProps, internalState, setCustomSelected } = gridState;
  const { brand } = externalProps;
  const { selectedAmount, setSelectedAmount, setSelectedVariantId } =
    internalState;

  if (!brand.variantDetailedResponse) return null;

  return (
    <div class="flex w-full flex-col gap-3">
      <For each={brand.variantDetailedResponse}>
        {(variant) => {
          const isSelected = () => selectedAmount() === variant.amount;

          return (
            <button
              class="relative flex h-9 w-full cursor-pointer items-center justify-between gap-2.5 rounded-lg border px-4 py-2.5 transition-colors"
              classList={{
                "border-stroke-solid bg-background-normal-primary": isSelected(),
                "border-stroke-2 bg-background-normal-primary hover:border-stroke-solid":
                  !isSelected(),
                "border-[1.5px]": isSelected(),
              }}
              onClick={() => {
                setCustomSelected(false);
                setSelectedVariantId(variant.variantId);
                setSelectedAmount(variant.amount);
              }}
            >
              <div
                class="flex-1 text-left"
                classList={{
                  "text-para-3-semi-bold text-text-normal-primary": isSelected(),
                  "text-para-3-medium text-text-normal-secondary":
                    !isSelected(),
                }}
              >
                <span>{variant.text}</span>
              </div>
              <div
                classList={{
                  "text-para-3-semi-bold text-text-normal-primary": isSelected(),
                  "text-para-3-medium text-text-normal-secondary":
                    !isSelected(),
                }}
              >
                <span>₹{variant.amount.toLocaleString()}</span>
              </div>
              <Show when={isSelected()}>
                <div class="absolute right-1 top-[3px] h-3 w-3 text-text-normal-primary">
                  <CheckIcon />
                </div>
              </Show>
            </button>
          );
        }}
      </For>
    </div>
  );
}
